import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { RdsDocumentSelectionListComponent } from './document-selection-list.component';

@NgModule({
  imports: [CommonModule, MatListModule, MatIconModule, FormsModule, FlexLayoutModule],
  declarations: [RdsDocumentSelectionListComponent],
  exports: [RdsDocumentSelectionListComponent],
})
export class RdsPackageDocumentSelectionModule {}

export * from './document-selection-list.component';
